export const MAIN_MENU_FIELDS = {
  EVENTS: 'events',
  UPCOMING_EVENTS: 'upcoming',
  PAST_EVENTS: 'past',
  DRAFT_EVENTS: 'draft',
  OFFERS: 'offers',
  CUSTOMERS: 'customers',
  MARKETING: 'marketing',
  ANALYTICS: 'analytics',
  INSIGHTS: 'insights',
};

export const MENU_FIELDS = {
  INFO: 'info',
  DETAILS: 'details',
  OFFERS: 'offers',
  PUBLISH: 'publish',
  VISIBILITY: 'visibility',
};
